import SEO from "@/components/SEO";

export default function MentionsLegales() {
  return (
    <>
      <SEO title="Mentions légales" description="Mentions légales de YAFORMIS — organisme de formation professionnelle en intelligence artificielle." path="/mentions-legales" />
      <section className="bg-white py-14 md:py-20" data-testid="mentions-page">
        <div className="max-w-3xl mx-auto px-5 md:px-8">
          <div className="overline">Mentions légales</div>
          <h1 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl mt-3 leading-tight text-brand-ink">Mentions légales</h1>
          <div className="mt-10 space-y-8 text-slate-700 leading-relaxed">
            <Block title="Éditeur du site">
              <p><strong>YAFORMIS</strong> — Organisme de formation professionnelle en intelligence artificielle.</p>
              <ul className="mt-3 space-y-1.5 text-[15px]">
                <li><b>Adresse :</b> 77 Bis rue Pierre Brossolette, 95200 Sarcelles</li>
                <li><b>Email :</b> <a href="mailto:yaformis@gmail.com" className="text-brand-blue hover:underline">yaformis@gmail.com</a></li>
                <li><b>Téléphone :</b> <a href="tel:+33626345597" className="text-brand-blue hover:underline">06 26 34 55 97</a></li>
                <li><b>SIRET :</b> 818 785 198 00065</li>
                <li><b>Numéro de déclaration d'activité (NDA) :</b> 11 93 07706 93</li>
                <li><b>Certification Qualiopi :</b> <a href="/certificat-qualiopi" className="text-brand-blue hover:underline">certificat n° 639711-3</a>, délivré par CERTIFOPAC au titre de la catégorie « Actions de formation » — valide du 14/08/2024 au 13/08/2027</li>
              </ul>
              <p className="mt-3 text-sm text-slate-500">Le numéro de déclaration d'activité ne vaut pas agrément de l'État (article L. 6352-12 du Code du travail).</p>
            </Block>

            <Block title="Hébergement">
              <p>Site hébergé sur une infrastructure cloud sécurisée. Données stockées en Union Européenne.</p>
            </Block>

            <Block title="Propriété intellectuelle">
              <p>L'ensemble du contenu du site (textes, programmes pédagogiques, logos, supports, photographies) est protégé par le droit d'auteur. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable de YAFORMIS est interdite.</p>
            </Block>

            <Block title="Conditions générales de formation">
              <p>L'inscription à une formation YAFORMIS est régie par une convention de formation professionnelle (B2B) ou un contrat de formation (particulier), conformément aux articles L. 6353-1 et suivants du Code du travail. Documents disponibles sur simple demande.</p>
            </Block>

            <Block title="Accessibilité">
              <p>YAFORMIS s'engage à rendre ses formations accessibles aux personnes en situation de handicap. Un référent handicap est à votre disposition pour adapter parcours et modalités. Contact : <a href="mailto:yaformis@gmail.com" className="text-brand-blue hover:underline">yaformis@gmail.com</a>.</p>
            </Block>

            <Block title="Protection des données personnelles">
              <p>
                Consultez notre <a href="/protection-donnees" className="text-brand-blue hover:underline font-semibold">politique de protection des données</a> pour connaître en détail nos engagements RGPD, la nature des traitements effectués et vos droits.
              </p>
            </Block>
          </div>
        </div>
      </section>
    </>
  );
}

function Block({ title, children }) {
  return (
    <section>
      <h2 className="font-heading font-bold text-2xl text-brand-ink border-l-2 border-brand-blue pl-4">{title}</h2>
      <div className="mt-3 space-y-2">{children}</div>
    </section>
  );
}
